export default __webpack_public_path__ + "static/media/skull2.71a17875.png";